export const PageDataState = {
    Searchs: {
        skills_set_type_id: {
            type: 'select',
            id: 'skills_set_type_id',
            label: 'ประเภททักษะ',
            value: '',
            placeholder: 'ประเภททักษะ Skills Set',
        },
        skills_set_name: {
            type: 'text',
            id: 'skills_set_name',
            label: 'ทักษะ',
            value: '',
            placeholder: 'ทักษะ Skills Set',
        },
        skills_set_status: {
            type: 'select',
            id: 'skills_set_status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        skills_set_type_id: {
            type: 'select',
            id: 'skills_set_type_id',
            label: 'ประเภททักษะ Skills Set',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'ทักษะ Skills Set',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        explain: {
            type: 'textarea',
            rows: 3,
            id: 'explain',
            label: 'คำอธิบาย Skill Set',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}